import { tradingSummary } from '@/utils/tradingSummary';
import AnimatedBar from '@/components/base/AnimatedBar';
import CountUp from '@/components/base/CountUp';
import Reveal from '@/components/base/Reveal';

function Directions() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto">
        <Reveal>
          <h2 className="text-center font-heading font-extrabold tracking-tight text-foreground-950 text-[30px] sm:text-[42px] lg:text-[50px]">
            Two Directions. One Market.
          </h2>
          <p className="mt-5 text-center text-[14px] md:text-[15px] leading-relaxed text-foreground-600 max-w-[640px] mx-auto">
            Long and short setups are judged by the same standard and read on their own merits —
            direction comes from the market, not from a preference. The recorded trades landed on
            both sides of it.
          </p>
        </Reveal>

        <Reveal delay={120} className="mt-14">
          <div className="rounded-lg border border-background-300 bg-background-50 p-6 md:p-9">
            <div className="grid grid-cols-2 gap-6 md:gap-0">
              <div className="md:pr-10">
                <span className="text-[11px] font-data tracking-[0.2em] text-foreground-500">
                  LONG
                </span>
                <p className="mt-3 font-data text-[52px] md:text-[72px] font-semibold text-foreground-950 leading-none">
                  <CountUp value={tradingSummary.longTrades} />
                </p>
                <p className="mt-3 font-data text-[14px] text-foreground-600">
                  {tradingSummary.longWinTrades} wins · {tradingSummary.longWinRate} win rate
                </p>
              </div>
              <div className="md:pl-10 md:border-l md:border-background-200 text-right">
                <span className="text-[11px] font-data tracking-[0.2em] text-foreground-500">
                  SHORT
                </span>
                <p className="mt-3 font-data text-[52px] md:text-[72px] font-semibold text-foreground-950 leading-none">
                  <CountUp value={tradingSummary.shortTrades} />
                </p>
                <p className="mt-3 font-data text-[14px] text-foreground-600">
                  {tradingSummary.shortWinTrades} wins · {tradingSummary.shortWinRate} win rate
                </p>
              </div>
            </div>

            <div className="mt-9">
              <div className="flex items-center justify-between mb-2.5">
                <span className="text-[11px] font-data tracking-[0.16em] text-foreground-600">
                  DIRECTIONAL SPLIT
                </span>
                <span className="text-[11px] font-data text-foreground-400">
                  {tradingSummary.totalTrades} RECORDED TRADES
                </span>
              </div>
              <div className="w-full h-2.5 rounded-full bg-foreground-900/80 overflow-hidden">
                <AnimatedBar
                  percent={tradingSummary.longPercent}
                  className="h-full rounded-l-full bg-primary-500"
                />
              </div>
              <div className="mt-2.5 flex items-center justify-between">
                <span className="flex items-center gap-2 text-[11px] text-foreground-600">
                  <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                  Long · {tradingSummary.longPercent.toFixed(1)}% of trades
                </span>
                <span className="flex items-center gap-2 text-[11px] text-foreground-600">
                  Short · {tradingSummary.shortPercent.toFixed(1)}% of trades
                  <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
                </span>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={180}>
          <p className="mt-8 text-center text-[13px] text-foreground-500">
            Directional split reflects recorded trade counts, not a forecast of market direction.
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default Directions;